import { Application } from '../../../types';
import { Tuple } from '../../../utill-types';

export const configHas1Application = (
  applications: Application[]
): applications is Tuple<Application, 1> => applications.length === 1;

export const configHas2Applications = (
  applications: Application[]
): applications is Tuple<Application, 2> => applications.length === 2;

export const configHas3Applications = (
  applications: Application[]
): applications is Tuple<Application, 3> => applications.length === 3;

export const configHas4Applications = (
  applications: Application[]
): applications is Tuple<Application, 4> => applications.length === 4;
